import { LiveMap } from 'src/features/live-map';

export function LiveMapRoute() {
  return <LiveMap />;
}
